import React, { useState } from 'react';
import PdfPopupRenderer from './PdfPopupRenderer'; // Adjust path as needed

const PdfPopup = () => {
  const [isPdfOpen, setIsPdfOpen] = useState(true); // Auto-open when component loads
  const pdfUrl = '/Demo_document_for_User_Management_Service_2.0.docx.pdf';  
  
  const handleClosePdf = () => {
    setIsPdfOpen(false);
  };

  return (
    <>
      <PdfPopupRenderer
        pdfUrl={pdfUrl}
        isOpen={isPdfOpen}
        onClose={handleClosePdf}
        scale={0.8}
      />
    </>
  );
};

export default PdfPopup;